import * as React from "react";

import backgroundColoursCss from "../../templates/utils/backgroundColoursCss";
import styled from "../../theme/styled";
import { MediumColumnWidthWrapper } from "../confines-wrappers";
import DynamicImage from "../dynamic-image";
import {
  IFieldTechnicalArticle,
  IFieldTechnicalArticleColumnType
} from "./field-technical-article";

interface IProps {
  type: IFieldTechnicalArticleColumnType;
  content: IFieldTechnicalArticle;
}

interface IParagraphBoxOutStackedImagesWrapper {
  className: string;
  type: IFieldTechnicalArticleColumnType;
  backgroundColors?: string[];
}

const ParagraphBoxOutStackedImagesWrapper = styled<
  IParagraphBoxOutStackedImagesWrapper,
  "div"
>("div")`
  .content-container {
    ${props => backgroundColoursCss(props.backgroundColors)};

    .content-wrapper {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .image {
        padding-top: 8%;
        width: 100%;

        &:first-child {
          padding-top: 0;
        }
      }
    }
  }

  @media (min-width: 600px) {
    .content-container {
      .content-wrapper {
        .image {
          padding-top: 4.4rem;
        }
      }
    }
  }
`;

const ParagraphBoxOutStackedImages = ({ type, content }: IProps) => {
  const imgRels = content.relationships;
  const images = imgRels && imgRels.field_images ? imgRels.field_images : [];
  const backgroundColors = content.field_background_colour_s_;

  if (images.length === 0) {
    return null;
  }

  return (
    <ParagraphBoxOutStackedImagesWrapper
      className="paragraph-box-out-stacked-images"
      type={type}
      backgroundColors={backgroundColors}
    >
      <div className="content-container">
        <MediumColumnWidthWrapper className="content-wrapper">
          {images &&
            images.map((image, i: number) => (
              <div
                className="image"
                key={i}
              >
                <DynamicImage
                  data={image}
                  alt={content.field_images[ i ].alt}
                />
              </div>
            ))}
        </MediumColumnWidthWrapper>
      </div>
    </ParagraphBoxOutStackedImagesWrapper>
  );
};

export default ParagraphBoxOutStackedImages;
